<ng-container *ngIf="CustomFormGroup.get(PropertyName).touched || CustomFormGroup.get(PropertyName).dirty">
    <ng-container *ngFor="let item of ValidationDictionary">
        <span class="validation" *ngIf="CustomFormGroup.hasError(item.Validation, PropertyName)">
            {{item.ErrorMessage}}
        </span>
    </ng-container>
</ng-container>